export const urlgetPictureList = '/api/XOrg/BookMaterial/getPictureList';



import http from 'lib//http';

export interface Ipicturelist{
    list:{
        picpath:string;
    }[]
}

export function getPictureList(id:string){
    return http.post<Ipicturelist>(urlgetPictureList,{
        id
    })
}

//获取当前课程下所有的课程
export const urlgetFaceTeachList ='/api/XOrg/BookMaterial/getFaceTeachList';
export interface FaceTeach{
    code:number,
    msg:string,
    faceTachList:{
        Id:string;
        ClassId:string,
        ClassName:string,
        FaceteachName:string,
        CreateDisplayName:string,
        ClassType:Number
    }[],
    pagination:{
        totalCount:number,
        pageSize:number,
        pageIndex:number
    }
}
export function getFaceTeachList(courseId:string,faceName:string,classId:string,pageSize?:number,page?:number){
    return http.post<FaceTeach>(urlgetFaceTeachList,{
        courseId,
        faceName,
        classId,
        pageSize,
        page
    })
}

//添加资源列表
export const urlAddSource='/api/XOrg/BookMaterial/AddSource';
export interface source{
    code:number,
    msg:string,
    DocUrl:string,
    DocExtension:string,
}
export function AddSource(Id:string,faceId:string,classId:string,courseId:string){
    return http.post<source>(urlAddSource,{
        Id,
        faceId,
        classId,
        courseId
    })
}
//获取课程下所有的班级
export const urlgetClassList='/api/XOrg/BookMaterial/getClassList';
export interface ClassList{
    code:number,
    msg:string,
    ClassList:{
        Id:string,
        ClassName:string
    }[]
}
export function getClassList(courseId:string){
    return http.post<ClassList>(urlgetClassList,{
        courseId
    })
}